export const campaignFromId = (state, id) =>
  state.entities.getIn(["campaign", id.toString()]);

export const campaignsFromIds = (state, ids) =>
  ids.map((id) => campaignFromId(state, id));

export const campaignsAll = (state) => {
  let campaignsfrom = campaignsFromIds(state, state.campaigns.ids);

  return campaignsfrom;
};

export const getCampaigns = (state) => campaignsAll(state).toJS();

export const getFilteredCampaigns = (state, query) => {
  let filteredCampaigns = getFilteredCampaignsByQuery(state, query);

  console.log("filteredCampaigns = ", filteredCampaigns);
  //return filteredCampaigns;
};

export const getFilteredCampaignsByQuery = (state, query) =>
  filteredCampaignsByQuery(state, query).toJS();

const campaignFilterFunction = (query) => (asset) =>
  asset.get("name").toLowerCase().includes(query);

const filteredCampaignsByQuery = (state, query) => {
  let filteredCampaigns = campaignsAll(state);

  query = query.trim().toLowerCase();

  if (query !== "") {
    filteredCampaigns = filteredCampaigns.filter(campaignFilterFunction(query));
  }

  return filteredCampaigns;
};



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/selectors/campaigns.js